import React, { useEffect, useState, useRef } from 'react';
import { Card, Col, Container, Row, Spinner } from 'react-bootstrap';
import '../../assets/css/Home/Home.css';
import StatCard from '../Card/StatCard';
import img1 from '../../assets/images/icons/transit-partner.png';
import img2 from '../../assets/images/icons/commuters.png';
import img3 from '../../assets/images/icons/active-vendors.png';
import img4 from '../../assets/images/icons/total-routes.png';
import img5 from '../../assets/images/icons/distance.png';
import img6 from '../../assets/images/icons/emission.png';
import img7 from '../../assets/images/icons/reward-points.png';
import img8 from '../../assets/images/icons/reward-redeem.png';
import redeemPoints from '../../assets/images/icons/5.png';
import { ReactComponent as GroceryBagIcon } from '../../assets/images/grocery-bag.svg';
import { ReactComponent as AllUsersIcon } from '../../assets/images/users.svg';
import { ReactComponent as StackCardsIcon } from '../../assets/images/stack-cards.svg';
import { Chart } from 'react-google-charts';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
import ghgSavedImg from '../../assets/images/icons/ghg-saved.svg';
import decryptData from '../../helpers/Decryption';
import { roundToInteger } from '../../helpers/utils';
import Select from 'react-select';
const FLOATED_TITLES = ['Distance', 'Rewards Points'];
const cards = [
    {
        id: 1,
        img_url: img1,
        title: 'Transit Agencies',
        counter: '22.4k',
        key: 'transitAgencies',
        text: 'Total Number of Transit Agencies',
        text_color: '#00A789'
    },
    {
        id: 2,
        img_url: img2,
        title: 'Commuters',
        counter: '254k',
        key: 'commuters',
        text: 'Total Number of Commuters',
        text_color: '#0059A7'
    },
    {
        id: 3,
        img_url: img4,
        title: 'Total Routes',
        counter: '254k',
        key: 'routes',
        text: 'Total Number of Approved Routes',
        text_color: '#FF9F43'
    },
    {
        id: 4,
        img_url: img5,
        title: 'Distance',
        key: 'totalDistance',
        counter: '22.4k',
        text: 'Total distance logged by Commuters',
        text_color: '#4007C9'
    },
    {
        id: 5,
        img_url: img3,
        title: 'Active Vendors',
        counter: '22.4k',
        key: 'vendors',
        text: 'Total Number of Vendors',
        color: '#7367F0'
    },
    {
        id: 6,
        img_url: img6,
        title: 'GHG Emissions Saved',
        key: 'GHGsaved',
        counter: '254',
        text: 'Total GHG Emissions saved',
        text_color: '#006C74',
        unit: 'kg'
    },
    {
        id: 7,
        img_url: img7,
        title: 'Rewards Points',
        key: 'earnedPoints',
        counter: '22.4k',
        text: 'Total Rewards Points Awarded',
        text_color: '#7367F0'
    },
    {
        id: 8,
        img_url: img8,
        title: 'Redeemed Rewards',
        counter: '254',
        key: 'totalRewards',
        text: 'Total Redeemed Rewards',
        text_color: '#FF9F43'
    }
];

// Add this helper function near the top (after imports)
function formatDateLabel(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

const Home = () => {
    const { user, getToken } = useAuth();
    const [allSettings, setAllSettings] = useState();
    const [userDetails, setUserDetails] = useState({});
    const [allUnits, setAllUnits] = useState();
    const [totalGHGSaved, setTotalGHGSaved] = useState(0);
    const [monthlyGhgStats, setMonthlyGhgStats] = useState([]);
    const [activeToggler, setActiveToggler] = useState('monthly');
    const [yearlyGhgStats, setYearlyGhgStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [commutersData, setCommutersData] = useState(false);
    const [pieChartState, setPieChartState] = useState({
        data: [],
        pieOptions: {
            pieHole: 0.5,
            titleTextStyle: {
                fontSize: 8
            },
            chartArea: { left: 10, top: 20, width: '100%', height: '100%' },
            legend: { position: 'right', alignment: 'end' }
        }
    });
    const [pieChartState1, setPieChartState1] = useState({});
    const [revenueState, setRevenueState] = useState({
        data: [],
        options: {
            bar: {
                width: 12,
                style: {
                    borderRadius: '50%'
                }
            },
            colors: ['#29CFB1', '#E1CC11'],
            hAxis: {
                minValue: 0
            },
            legend: {
                position: 'none'
            }
        }
    });
    const [redemptionAnalytics, setRedemptionAnalytics] = useState({});
    const [agencyAnalyticsCharts, setAgencyAnalyticsCharts] = useState({});
    const [redemptionsRange, setRedemptionsRange] = useState('1d');
    const [pointsRange, setPointsRange] = useState('1d');
    const [redemptionsChartLoading, setRedemptionsChartLoading] = useState(false);
    const [pointsChartLoading, setPointsChartLoading] = useState(false);
    // Track which filter was last changed
    const lastChartFilterChanged = useRef(null); // 'redemptions' | 'points' | null

    useEffect(() => {
        setUser(user);
        if (user?.role === 'agency') {
            getAgencyDashboardKpis();
        }

        if (user?.role === 'admin') {
            getAllSettings();
            // getMeasuringUnits();
        }
    }, [user]);

    useEffect(() => {
        if (user?.role === 'commuter' && userDetails?._id) {
            getDashboardCommuter();
        }
    }, [userDetails?._id]);

    useEffect(() => {
        if (user?.role === 'vendor' && userDetails?._id) {
            getVendorAnalyticsData();
        }
        // eslint-disable-next-line
    }, [userDetails?._id, redemptionsRange, pointsRange]);

    const getDashboardCommuter = () => {
        const authToken = getToken();
        if (authToken) {
            setLoading(true);
            new WebApiCalls().getCommuterDasboardData(authToken, userDetails?._id, userDetails?.created_at, new Date().toISOString()).then((res) => {
                setCommutersData(res?.data);
            });
        }
    };

    const getVendorAnalyticsData = async () => {
        const authToken = getToken();
        if (authToken) {
            setLoading(true);
            if (lastChartFilterChanged.current === 'redemptions') {
                setRedemptionsChartLoading(true);
            } else if (lastChartFilterChanged.current === 'points') {
                setPointsChartLoading(true);
            }
            new WebApiCalls()
                .getVendorAnalytics(authToken, userDetails?._id, redemptionsRange, pointsRange)
                .then(async (res) => {
                    if (res?.code === 200 && res?.result === 'success') {
                        const decryptedData = await decryptData(res.data);
                        console.log('decryptedData', decryptedData);
                        const analyticsData = decryptedData.stats;
                        const analyticsChartsData = decryptedData.charts;

                        const updatedCards = [
                            {
                                id: 1,
                                img_url: img1,
                                title: 'Total Branches',
                                counter: analyticsData.totalBranches,
                                key: 'totalBranches',
                                text: 'Total number of branches created by the vendor',
                                text_color: '#00A789'
                            },
                            {
                                id: 2,
                                img_url: null,
                                icon: <GroceryBagIcon className="all-users-icon icon-blue" />,
                                title: 'Total Rewards',
                                counter: analyticsData.totalOffers,
                                key: 'totalOffers',
                                text: 'Total number of active and inactive rewards',
                                text_color: '#0059A7'
                            },
                            {
                                id: 3,
                                img_url: null,
                                icon: <StackCardsIcon className="all-users-icon icon-blue" />,
                                title: 'Total Redemptions',
                                counter: analyticsData.totalRedemptions,
                                key: 'totalRedemptions',
                                text: 'Total number of redemptions made by commuters',
                                text_color: '#FF9F43'
                            },
                            {
                                id: 4,
                                img_url: redeemPoints,
                                title: 'Cash Value of Redeemed Points',
                                counter: analyticsData.totalPointsRedeemed / 100,
                                key: 'totalPointsRedeemed',
                                text: 'Total reward points redeemed by commuters',
                                text_color: '#4007C9'
                            },
                            {
                                id: 5,
                                img_url: img5,
                                title: 'Top Performing Branch',
                                counter: analyticsData.topPerformingBranch,
                                key: 'topPerformingBranch',
                                text: 'Branch with the highest number of redemptions',
                                text_color: '#7367F0'
                            },
                            {
                                id: 6,
                                img_url: img6,
                                title: 'Top Redeemed Reward',
                                counter: analyticsData.topRedeemedOffer,
                                key: 'topRedeemedOffer',
                                text: 'Most redeemed offer by commuters',
                                text_color: '#006C74'
                            },
                            {
                                id: 8,
                                img_url: img8,
                                title: 'Total Dollar Cost of Rewards',
                                counter: analyticsData.revenueGenerated,
                                key: 'revenueGenerated',
                                text: "Total revenue generated from rewards' redemptions",
                                text_color: '#29CFB1'
                            }
                        ];

                        setRedemptionAnalytics(analyticsChartsData);
                        setAllSettings(updatedCards);
                    }
                })
                .catch((err) => {
                    console.error('Error fetching vendor analytics:', err);
                })
                .finally(() => {
                    setLoading(false);
                    if (lastChartFilterChanged.current === 'redemptions') {
                        setRedemptionsChartLoading(false);
                    } else if (lastChartFilterChanged.current === 'points') {
                        setPointsChartLoading(false);
                    }
                    lastChartFilterChanged.current = null;
                });
        }
    };

    const getAgencyDashboardKpis = async () => {
        const authToken = getToken();
        if (authToken && user?._id) {
            setLoading(true);
            new WebApiCalls()
                .getAgencyDashboardKpis(authToken, user._id)
                .then((res) => {
                    if (res?.code === 200 && res?.result === 'success') {
                        const kpis = res.data || {};
                        // Extract latest month count for monthly arrays
                        const latestActiveUsersMonthly =
                            Array.isArray(kpis.activeUsersMonthly) && kpis.activeUsersMonthly.length > 0
                                ? kpis.activeUsersMonthly[kpis.activeUsersMonthly.length - 1].count
                                : 0;
                        const latestNewUsersMonthly =
                            Array.isArray(kpis.newUsersMonthly) && kpis.newUsersMonthly.length > 0 ? kpis.newUsersMonthly[kpis.newUsersMonthly.length - 1].count : 0;
                        setAgencyAnalyticsCharts({
                            activeUsersHistory: kpis.activeUsersMonthly || [],
                            routesRanked: kpis.routesRanked || [],
                            stopsRanked: kpis.stopsRanked || []
                        });
                        // Map new API fields to cards
                        const agencyCards = [
                            {
                                id: 1,
                                img_url: null,
                                icon: <AllUsersIcon className="all-users-icon icon-blue" />,
                                title: 'Total Users',
                                counter: kpis.totalUsers,
                                key: 'totalUsers',
                                text: 'Total number of users',
                                text_color: '#0059A7' // blue
                            },
                            {
                                id: 2,
                                img_url: null,
                                icon: <AllUsersIcon className="all-users-icon icon-green" />,
                                title: 'Active Users',
                                counter: kpis.activeUsers,
                                key: 'activeUsers',
                                text: 'Active users (last 7 days)',
                                text_color: '#00A789' // green (main)
                            },
                            {
                                id: 3,
                                img_url: null,
                                icon: <AllUsersIcon className="all-users-icon icon-light-green" />,
                                title: 'Active Users (Monthly)',
                                counter: latestActiveUsersMonthly,
                                key: 'activeUsersMonthly',
                                text: 'Active users (latest month)',
                                text_color: '#29CFB1' // green (light)
                            },
                            {
                                id: 4,
                                img_url: null,
                                icon: <AllUsersIcon className="all-users-icon icon-yellow" />,
                                title: 'New Users',
                                counter: kpis.newUsers,
                                key: 'newUsers',
                                text: 'New users (last 7 days)',
                                text_color: '#E1CC11' // yellow (main)
                            },
                            {
                                id: 5,
                                img_url: null,
                                icon: <AllUsersIcon className="all-users-icon icon-light-yellow" />,
                                title: 'New Users (Monthly)',
                                counter: latestNewUsersMonthly,
                                key: 'newUsersMonthly',
                                text: 'New users (latest month)',
                                text_color: '#FF9F43' // yellow (light)
                            },
                            {
                                id: 6,
                                img_url: img5,
                                title: 'Avg Trip Length',
                                counter: kpis.avgTripLength,
                                key: 'avgTripLength',
                                text: 'Average trip length',
                                text_color: '#4007C9'
                            },
                            {
                                id: 9,
                                img_url: img6,
                                title: 'GHG Emissions Saved',
                                counter: kpis.totalGHGSaved,
                                key: 'totalGHGSaved',
                                text: 'Total GHG Emissions saved',
                                text_color: '#FF9F43',
                                unit: 'kg'
                            }
                        ];
                        setTotalGHGSaved(Math.floor(kpis.totalGHGSaved || 0));
                        setAllSettings(agencyCards);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                })
                .finally(() => setLoading(false));
        }
    };

    const setUser = (user) => {
        if (user) {
            setUserDetails(user);
        }
    };
    const handleToggleStats = async (intervalType) => {
        if (intervalType === 'monthly') {
            setRevenueState({ ...revenueState, data: monthlyGhgStats });
        }
        if (intervalType === 'yearly') {
            setRevenueState({ ...revenueState, data: yearlyGhgStats });
        }
        setActiveToggler(intervalType);
    };
    const getAllSettings = async () => {
        const authToken = getToken();
        if (authToken) {
            setLoading(true);
            new WebApiCalls()
                .getCommonSettings(authToken)
                .then((res) => {
                    if (res?.code && res?.code == 200 && res?.result == 'success') {
                        setRevenueState({ ...revenueState, data: res.data.monthWiseGHGStats });
                        setActiveToggler('monthly');
                        setMonthlyGhgStats(res.data.monthWiseGHGStats);
                        setYearlyGhgStats(res.data.yearWiseGHGStats);
                        setTotalGHGSaved(Math.floor(res.data.GHGsaved));
                        let updatedCards = cards.map((item) => {
                            if (Object.keys(res.data).find((_item) => _item == item?.key)) {
                                let counterValue = res?.data[item?.key];
                                if (item.title === 'GHG Emissions Saved') {
                                    counterValue = parseInt(counterValue, 10);
                                }
                                return {
                                    ...item,
                                    counter: FLOATED_TITLES.includes(item.title) ? roundToInteger(counterValue) : counterValue
                                };
                            } else {
                                return { ...item };
                            }
                        });
                        let data = [['Region', 'No of users'], ...(res.data?.regionUsers || [])];
                        setPieChartState1({
                            data,
                            pieOptions: {
                                pieHole: 0.4,
                                chartArea: { left: 10, top: 20, width: '100%', height: '100%' },
                                legend: { position: 'right', alignment: 'center' }
                            }
                        });

                        setPieChartState({
                            data: [['Agency', 'Commuter per Agency'], ...res.data?.commuterPerAgency],
                            pieOptions: {
                                pieHole: 0.4,
                                titleTextStyle: {
                                    fontSize: 20
                                },
                                chartArea: { left: 10, top: 20, width: '100%', height: '100%' },
                                legend: { position: 'right', alignment: 'center' }
                            }
                        });
                        setAllSettings(updatedCards);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                })
                .finally(() => [setLoading(false)]);
        }
    };

    const getMeasuringUnits = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code == 200) {
                        setAllUnits(res?.data);
                    }
                })
                .catch((err) => {});
        }
    };

    const renderGHGValue = (value) => {
        return <strong>{value}</strong>;
    };

    // Transform redemptionHeatmap for GeoChart custom tooltip (3 columns only)
    let redemptionHeatmapData = redemptionAnalytics.redemptionHeatmap;
    if (redemptionHeatmapData && redemptionHeatmapData.length > 1) {
        redemptionHeatmapData = [
            ['Latitude', 'Longitude', { type: 'string', role: 'tooltip', p: { html: true } }],
            ...redemptionHeatmapData.slice(1).map((row) => [row[0], row[1], `<div><b>${row[2]}</b><br/>Redemptions: <b>${row[3]}</b></div>`])
        ];
    }

    // Prepare chart data for active users history
    let activeUsersHistoryChartData = [];
    if (userDetails.role === 'agency' && agencyAnalyticsCharts.activeUsersHistory && agencyAnalyticsCharts.activeUsersHistory.length > 0) {
        activeUsersHistoryChartData = [['Month', 'Active Users'], ...agencyAnalyticsCharts.activeUsersHistory.map((item) => [item.month, item.count])];
    }

    // Prepare chart data for routesRanked and stopsRanked
    let routesRankedChartData = [];
    if (userDetails.role === 'agency' && agencyAnalyticsCharts.routesRanked && agencyAnalyticsCharts.routesRanked.length > 0) {
        // Google Charts BarChart expects the first column to be a string (label), second column a number (value)
        routesRankedChartData = [
            ['Route', 'Users'],
            ...agencyAnalyticsCharts.routesRanked.map((item) => [
                item.routeName || '', // Use routeName as label
                item.userCount || 0 // Use userCount as value
            ])
        ];
    }

    let stopsRankedChartData = [];
    if (userDetails.role === 'agency' && agencyAnalyticsCharts.stopsRanked && agencyAnalyticsCharts.stopsRanked.length > 0) {
        stopsRankedChartData = [
            ['Stop', 'Users'],
            ...agencyAnalyticsCharts.stopsRanked.map((item) => [
                item.stationName || '', // Use stationName as label
                item.userCount || 0 // Use userCount as value
            ])
        ];
    }


    // Helper to filter chart data for last 1 day or 7 days
    function filterChartDataByRange(data, range) {
        if (!Array.isArray(data) || data.length < 2) return data;
        const now = new Date();
        let cutoff;
        if (range === '1d') {
            cutoff = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        } else {
            cutoff = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        }
        // Data: [header, ...[date, bin, count]]
        // Only keep rows where the constructed Date is >= cutoff
        return [
            data[0],
            ...data.slice(1).filter(([date, bin]) => {
                // date is string, bin is number (hour bin)
                // Construct a Date object for comparison
                if (!date || typeof bin !== 'number') return false;
                const d = new Date(`${date}T${(bin + 3).toString().padStart(2, '0')}:00:00`);
                return d >= cutoff;
            })
        ];
    }

    // Process redemptionsChartProcessed and pointsChartProcessed for 6-hour bins
    let redemptionsChartProcessed = [];
    if (redemptionAnalytics && redemptionAnalytics.redemptionsOverTime) {
        const redemptionsChartData = redemptionAnalytics.redemptionsOverTime;
        if (redemptionsChartData[0][0] === 'DateTime') {
            redemptionsChartProcessed = [
                ['DateTime', 'Redemptions'],
                ...redemptionsChartData.slice(1).map(([dateStr, value]) => {
                    // Parse the date string and create a local date object without timezone conversion
                    // Assuming dateStr is in format "YYYY-MM-DDTHH:mm:ss" (local time)
                    const [datePart, timePart] = dateStr.split('T');
                    const [year, month, day] = datePart.split('-');
                    const [hour, minute, second] = timePart.split(':');
                    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute), parseInt(second));
                    return [date, value];
                })
            ];
        }
    }
    let pointsChartProcessed = [];
    if (redemptionAnalytics && redemptionAnalytics.pointsRedeemedOverTime) {
        const pointsChartData = redemptionAnalytics.pointsRedeemedOverTime;
        if (pointsChartData[0][0] === 'DateTime') {
            pointsChartProcessed = [
                ['DateTime', 'Points'],
                ...pointsChartData.slice(1).map(([dateStr, value]) => {
                    // Parse the date string and create a local date object without timezone conversion
                    // Assuming dateStr is in format "YYYY-MM-DDTHH:mm:ss" (local time)
                    const [datePart, timePart] = dateStr.split('T');
                    const [year, month, day] = datePart.split('-');
                    const [hour, minute, second] = timePart.split(':');
                    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day), parseInt(hour), parseInt(minute), parseInt(second));
                    return [date, value];
                })
            ];
        }
    }
    // hAxis options for 1d and 7d
    function get6HourTicks(startDate) {
        const ticks = [];
        for (let h = 0; h < 24; h += 6) {
            const d = new Date(startDate);
            d.setHours(h, 0, 0, 0);
            ticks.push(d);
        }
        // Add next day's midnight for closure
        const d = new Date(startDate);
        d.setDate(d.getDate() + 1);
        d.setHours(0, 0, 0, 0);
        ticks.push(d);
        return ticks;
    }

    function getDayBinsTicks(date) {
        const dateStr = date.toISOString().slice(0, 10);
        return [
            new Date(`${dateStr}T00:00:00`),
            new Date(`${dateStr}T06:00:00`),
            new Date(`${dateStr}T12:00:00`),
            new Date(`${dateStr}T18:00:00`),
            new Date(`${dateStr}T24:00:00`),
        ];
    }

    const handleRedemptionsRangeChange = (opt) => {
        lastChartFilterChanged.current = 'redemptions';
        setRedemptionsRange(opt.value);
    };
    const handlePointsRangeChange = (opt) => {
        lastChartFilterChanged.current = 'points';
        setPointsRange(opt.value);
    };

    let redemptionsChartWithTooltip = redemptionsChartProcessed;
    if (redemptionsRange === '7d' && redemptionsChartProcessed.length > 1) {
        redemptionsChartWithTooltip = [
            ['Date', 'Redemptions', { role: 'tooltip', type: 'string', p: { html: true } }],
            ...redemptionsChartProcessed.slice(1).map(([date, value]) => [date, value, `<span style="white-space:nowrap; padding:3px">Redemptions:&nbsp;${value}</span>`])
        ];
    } else if (redemptionsRange === '1d' && redemptionsChartProcessed.length > 1) {
        redemptionsChartWithTooltip = [
            ['DateTime', 'Redemptions', { role: 'tooltip', type: 'string', p: { html: true } }],
            ...redemptionsChartProcessed.slice(1).map(([date, value]) => [date, value, `<span style="white-space:nowrap; padding:3px">Redemptions:&nbsp;${value}</span>`])
        ];
    }

    let pointsChartWithTooltip = pointsChartProcessed;
    if (pointsRange === '7d' && pointsChartProcessed.length > 1) {
        pointsChartWithTooltip = [
            ['Date', 'Points', { role: 'tooltip', type: 'string', p: { html: true } }],
            ...pointsChartProcessed.slice(1).map(([date, value]) => [date, value, `<span style="white-space:nowrap; padding:3px;">Points:&nbsp;${value}</span>`])
        ];
    } else if (pointsRange === '1d' && pointsChartProcessed.length > 1) {
        pointsChartWithTooltip = [
            ['DateTime', 'Points', { role: 'tooltip', type: 'string', p: { html: true } }],
            ...pointsChartProcessed.slice(1).map(([date, value]) => [date, value, `<span style="white-space:nowrap; padding:3px;">Points:&nbsp;${value}</span>`])
        ];
    }

    if (!allSettings && loading && !commutersData) {
        return (
            <div className="text-center">
                <Spinner animation="border" variant="success" />
            </div>
        );
    }
    if (!allSettings && !loading && !commutersData) {
        return <div className="text-center">No data found</div>;
    }

    return (
        <Container fluid className="mt-3 inner-content">
            <Row className="mb-4">
                <Col sm={12} md={12} lg={12} xl={12} className="mt-4">
                    {userDetails.role === 'agency' && totalGHGSaved > 0 && (
                        <Card className="first-card card-wrapper text-center">
                            <Card.Body>
                                <Card.Img className="img-fluid" variant="center" src={require('../../assets/images/icons/home-icon.png')} alt="" width={150} />
                                <Card.Title className="title-text">Congratulations</Card.Title>
                                <Card.Title className="card-small-text my-2">
                                    You have saved <strong>{totalGHGSaved} kilograms</strong> of GHG emissions today.
                                </Card.Title>
                            </Card.Body>
                        </Card>
                    )}
                </Col>
                {userDetails.role === 'commuter' && (
                    <>
                        {commutersData?.GHGsaved > 0 ? (
                            <Col sm={12} md={12} lg={12} xl={12} className="mt-4">
                                <Card className="first-card card-wrapper text-center">
                                    <Card.Body>
                                        <Card.Img className="img-fluid" variant="center" src={require('../../assets/images/icons/home-icon.png')} alt="" width={150} />
                                        <Card.Title className="title-text">Congratulations</Card.Title>
                                        <Card.Title className="card-small-text my-2">
                                            You have saved <strong>{Math.floor(commutersData?.GHGsaved)} kilograms</strong> of GHG emissions today.
                                        </Card.Title>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ) : (
                            <Row>
                                <Col sm={12} md={12} lg={12} xl={12} className="mt-4">
                                    <Card className="second-card card-wrapper text-center">
                                        <Card.Body>
                                            <Card.Img className="card-img" variant="center" src={ghgSavedImg} alt="" />
                                            <Card.Title className="card-title my-2">Earn points with every trip you take!</Card.Title>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        )}
                    </>
                )}
                {userDetails.role === 'commuter' &&
                    [
                        {
                            key: 'GHGsaved',
                            value: 'GHG Saved',
                            img_url:
                                'data:image/png;base64,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'
                        },
                        {
                            key: 'reward_points',
                            value: 'Lifetime Transit Reward Points',
                            img_url:
                                'data:image/png;base64,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'
                        },
                        {
                            key: 'tier',
                            value: 'Tier',
                            img_url:
                                'data:image/png;base64,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'
                        }
                    ].map((item) => {
                        return (
                            <Col sm={12} md={3} lg={3} xl={3} className="mt-4" key={item.key}>
                                <StatCard counter={commutersData?.[item.key]} img_url={item?.img_url || ''} title={item.value} units={allUnits} />
                            </Col>
                        );
                    })}
                {/* Append new cards for Reward Points, Redeemable Points, Next Reward Level */}
                {commutersData?.rewardPoints !== undefined && (
                    <Col sm={12} md={3} lg={3} xl={3} className="mt-4">
                        <StatCard counter={commutersData.rewardPoints} img_url={img7} title="Reward Points" units={allUnits} />
                    </Col>
                )}
                {commutersData?.redeemablePoints !== undefined && (
                    <Col sm={12} md={3} lg={3} xl={3} className="mt-4">
                        <StatCard counter={commutersData.redeemablePoints} img_url={img8} title="Redeemable Points" units={allUnits} />
                    </Col>
                )}
                {commutersData?.nextRewardLevel !== undefined && (
                    <Col sm={12} md={3} lg={3} xl={3} className="mt-4">
                        <StatCard counter={commutersData.nextRewardLevel} img_url={img7} title="Next Reward Level" units={allUnits} />
                    </Col>
                )}
                {allSettings?.map((item) => {
                    if (userDetails.role == 'agency' && item?.title === 'Transit Agencies') {
                        return;
                    }

                    return (
                        <Col sm={12} md={3} lg={3} xl={3} className="mt-4" key={item?.id}>
                            <StatCard {...item} units={allUnits} />
                        </Col>
                    );
                })}
                {allSettings && user.role === 'admin' && (
                    <Row id={'chartId'} style={{ paddingRight: 0 }}>
                        {allSettings && userDetails?.role !== 'agency' && (
                            <Col md={6} className="mt-4 ">
                                <Card className="card-wrapper p-4" height={145}>
                                    <div className="d-flex align-items-center flex-wrap">
                                        <h3 className="chart-heading">Commuters by transit agency</h3>
                                        <Chart chartType="PieChart" data={pieChartState.data} options={pieChartState?.pieOptions} width="100%" />
                                    </div>
                                </Card>
                            </Col>
                        )}

                        {allSettings && userDetails?.role !== 'agency' && (
                            <Col md={6} className="mt-4 pr-0" style={{ paddingRight: 0 }}>
                                <Card className="card-wrapper p-4" height={145}>
                                    <div className="d-flex align-items-center flex-wrap">
                                        <h3 className="chart-heading">Commuters per province</h3>
                                        <Chart chartType="PieChart" data={pieChartState1.data} options={pieChartState1?.pieOptions} width="100%" />
                                    </div>
                                </Card>
                            </Col>
                        )}

                        {allSettings && (
                            <Col sm={12} md={8} lg={8} xl={6} className="mt-4">
                                <Card className="card-wrapper p-1">
                                    <Card.Header className="bg-white p-3 border-0">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h3 className="chart-heading">
                                                GHG Emissions Saved
                                                <span style={{ fontSize: '0.9rem', marginLeft: 8, color: '#888' }}>
                                                    {/* Replace 'kg' with dynamic unit if available: allUnits?.ghgUnit */}
                                                    (kg)
                                                </span>
                                            </h3>
                                            <div className="hint-wrapper">
                                                <select
                                                    value={activeToggler}
                                                    onChange={(e) => {
                                                        e.preventDefault();
                                                        handleToggleStats(e.target.value);
                                                    }}
                                                    className={'status-selector'}
                                                    aria-label="Default select example"
                                                >
                                                    <option value={'monthly'}>Monthly</option>
                                                    <option value={'yearly'}>Yearly</option>
                                                </select>
                                            </div>
                                        </div>
                                    </Card.Header>
                                    <Card.Body className="graph-revenue-report">
                                        <Chart
                                            chartType="ColumnChart"
                                            width="100%"
                                            height="145px"
                                            data={revenueState.data}
                                            options={{
                                                ...revenueState.options,
                                                vAxis: {
                                                    ...revenueState.options.vAxis,
                                                    title: 'GHG Saved (kg)' // Add unit to axis title
                                                }
                                            }}
                                        />
                                    </Card.Body>
                                </Card>
                            </Col>
                        )}
                    </Row>
                )}
            </Row>
            {/* Agency analytics charts */}
            {user.role === 'agency' && (
                <Row className="mb-4">
                    {/* Active Users Over Time */}
                    {activeUsersHistoryChartData.length > 1 && (
                        <Col sm={12} md={6} lg={6} xl={6} className="mt-4">
                            <Card className="card-wrapper p-4">
                                <h3 className="chart-heading">Active Users Over Time</h3>
                                <Chart
                                    chartType="LineChart"
                                    data={activeUsersHistoryChartData}
                                    options={{
                                        title: 'Active Users Over Time',
                                        hAxis: { title: 'Month' },
                                        vAxis: { title: 'Active Users' }
                                    }}
                                    width="100%"
                                    height="300px"
                                />
                            </Card>
                        </Col>
                    )}
                    {/* Top Routes */}
                    {routesRankedChartData.length > 1 && (
                        <Col sm={12} md={6} lg={6} xl={6} className="mt-4">
                            <Card className="card-wrapper p-4">
                                <h3 className="chart-heading">Top Routes</h3>
                                <Chart
                                    chartType="BarChart"
                                    data={routesRankedChartData}
                                    options={{
                                        title: 'Top Routes',
                                        hAxis: { title: 'Users' },
                                        vAxis: { title: 'Route' }
                                    }}
                                    width="100%"
                                    height="300px"
                                />
                            </Card>
                        </Col>
                    )}
                    {/* Top Stops */}
                    {stopsRankedChartData.length > 1 && (
                        <Col sm={12} md={6} lg={6} xl={6} className="mt-4">
                            <Card className="card-wrapper p-4">
                                <h3 className="chart-heading">Top Stops</h3>
                                <Chart
                                    chartType="BarChart"
                                    data={stopsRankedChartData}
                                    options={{
                                        title: 'Top Stops',
                                        hAxis: { title: 'Users' },
                                        vAxis: { title: 'Stop' }
                                    }}
                                    width="100%"
                                    height="300px"
                                />
                            </Card>
                        </Col>
                    )}
                </Row>
            )}
            {redemptionAnalytics && (
                <Row className="mb-4">
                
                    {/* Branch Performance (last 7 days) */}
                    {redemptionAnalytics.branchPerformance && (
                        <Col sm={12} md={6} lg={6} xl={6} className="mt-4">
                            <Card className="card-wrapper p-4">
                                <h3 className="chart-heading">Branch Performance (Last 7 Days)</h3>
                                <Chart
                                    chartType="BarChart"
                                    data={redemptionAnalytics.branchPerformance.map((row, idx) => (idx === 0 ? row : [row[0], Math.floor(row[1])]))}
                                    options={{
                                        title: 'Branch Performance (Last 7 Days)',
                                        hAxis: { title: 'Redemptions' },
                                        vAxis: {
                                            title: 'Branches',
                                            format: '0', // integer format
                                            viewWindow: { min: 0 },
                                            gridlines: { count: -1 },
                                            ticks: (function () {
                                                if (!redemptionAnalytics.branchPerformance || redemptionAnalytics.branchPerformance.length < 2) return [];
                                                const max = Math.max(...redemptionAnalytics.branchPerformance.slice(1).map((row) => Math.floor(row[1])));
                                                return Array.from({ length: max + 1 }, (_, i) => i);
                                            })()
                                        }
                                    }}
                                    width="100%"
                                    height="300px"
                                />
                            </Card>
                        </Col>
                    )}
                    {/* Reward Performance */}
                    {redemptionAnalytics.offerPerformance && (
                        <Col sm={12} md={6} lg={6} xl={6} className="mt-4">
                            <Card className="card-wrapper p-4">
                                <h3 className="chart-heading">Reward Performance</h3>
                                <Chart
                                    chartType="PieChart"
                                    data={redemptionAnalytics.offerPerformance || []}
                                    options={{ title: 'Reward Performance' }}
                                    width="100%"
                                    height="300px"
                                />
                            </Card>
                        </Col>
                    )}
                        {/* Redemptions Over Time */}
                        {userDetails.role === 'vendor' && (
                    <Col sm={12} md={12} lg={12} xl={12} className="mt-4">
                        <Card className="card-wrapper p-4">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h3 className="chart-heading mb-0">Redemptions Over Time</h3>
                                <Select
                                    options={[
                                        { value: '1d', label: 'Last 1 day' },
                                        { value: '7d', label: 'Last 7 days' },
                                    ]}
                                    value={[
                                        { value: '1d', label: 'Last 1 day' },
                                        { value: '7d', label: 'Last 7 days' },
                                    ].find(opt => opt.value === redemptionsRange)}
                                    onChange={handleRedemptionsRangeChange}
                                    classNamePrefix="react-select"
                                    styles={{ container: base => ({ ...base, minWidth: 140 }) }}
                                    isSearchable={false}
                                />
                            </div>
                            <div style={{ position: 'relative' }}>
                                {redemptionsChartLoading && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        background: 'rgba(255,255,255,0.7)',
                                        zIndex: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: 8
                                    }}>
                                        <Spinner animation="border" variant="primary" />
                                    </div>
                                )}
                                {redemptionsChartProcessed.length > 1 ? (
                                    <Chart
                                        chartType="LineChart"
                                        data={redemptionsChartWithTooltip}
                                        options={{
                                            title: 'Redemptions Over Time',
                                            hAxis: {
                                                title: redemptionsRange === '1d' ? 'Time' : 'Date',
                                                ...(redemptionsRange === '1d'
                                                    ? {
                                                        gridlines: { count: 5 },
                                                        minorGridlines: { count: 0 },
                                                        ticks: (() => {
                                                            let minDate = null;
                                                            if (redemptionsChartProcessed.length > 1) {
                                                                minDate = redemptionsChartProcessed[1][0];
                                                            }
                                                            return minDate ? get6HourTicks(minDate) : [];
                                                        })(),
                                                        format: 'HH:mm',
                                                    }
                                                    : {
                                                        gridlines: { count: 8 },
                                                        minorGridlines: { count: 4 },
                                                        format: 'MMM d, YYYY',
                                                    })
                                            },
                                            vAxis: { title: 'Redemptions' },
                                            legend: { position: 'none' },
                                            pointSize: 6,
                                            tooltip: { isHtml: true },
                                        }}
                                        width="100%"
                                        height="300px"
                                    />
                                ) : (
                                    <div style={{
                                        height: '300px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#666',
                                        fontSize: '16px',
                                        fontWeight: '500'
                                    }}>
                                        No data to show
                                    </div>
                                )}
                            </div>
                        </Card>
                    </Col>
                    )}
               
                    {/* Points Redeemed Over Time */}
                    {userDetails.role === 'vendor' && (
                    <Col sm={12} md={12} lg={12} xl={12} className="mt-4">
                        <Card className="card-wrapper p-4">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h3 className="chart-heading mb-0">Points Redeemed Over Time</h3>
                                <Select
                                    options={[
                                        { value: '1d', label: 'Last 1 day' },
                                        { value: '7d', label: 'Last 7 days' },
                                    ]}
                                    value={[
                                        { value: '1d', label: 'Last 1 day' },
                                        { value: '7d', label: 'Last 7 days' },
                                    ].find(opt => opt.value === pointsRange)}
                                    onChange={handlePointsRangeChange}
                                    classNamePrefix="react-select"
                                    styles={{ container: base => ({ ...base, minWidth: 140 }) }}
                                    isSearchable={false}
                                />
                            </div>
                            <div style={{ position: 'relative' }}>
                                {pointsChartLoading && (
                                    <div style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        background: 'rgba(255,255,255,0.7)',
                                        zIndex: 2,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: 8
                                    }}>
                                        <Spinner animation="border" variant="primary" />
                                    </div>
                                )}
                                {pointsChartProcessed.length > 1 ? (
                                    <Chart
                                        chartType="LineChart"
                                        data={pointsChartWithTooltip}
                                        options={{
                                            title: 'Points Redeemed Over Time',
                                            hAxis: {
                                                title: pointsRange === '1d' ? 'Time' : 'Date',
                                                ...(pointsRange === '1d'
                                                    ? {
                                                        gridlines: { count: 5 },
                                                        minorGridlines: { count: 0 },
                                                        ticks: (() => {
                                                            let minDate = null;
                                                            if (pointsChartProcessed.length > 1) {
                                                                minDate = pointsChartProcessed[1][0];
                                                            }
                                                            return minDate ? get6HourTicks(minDate) : [];
                                                        })(),
                                                        format: 'HH:mm',
                                                    }
                                                    : {
                                                        gridlines: { count: 8 },
                                                        minorGridlines: { count: 0 },
                                                        format: 'MMM d',
                                                    })
                                            },
                                            vAxis: { title: 'Points' },
                                            legend: { position: 'none' },
                                            pointSize: 6,
                                            tooltip: { isHtml: true },
                                        }}
                                        width="100%"
                                        height="300px"
                                    />
                                ) : (
                                    <div style={{
                                        height: '300px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#666',
                                        fontSize: '16px',
                                        fontWeight: '500'
                                    }}>
                                        No data to show
                                    </div>
                                )}
                            </div>
                        </Card>
                    </Col>
                    )}
                    {/* Redemption Heatmap */}
                    {redemptionAnalytics.redemptionHeatmap && (
                        <Col sm={12} md={6} lg={6} xl={6} className="mt-4">
                            <Card className="card-wrapper p-4">
                                <h3 className="chart-heading">Redemption Heatmap</h3>
                                <Chart
                                    chartType="GeoChart"
                                    data={redemptionHeatmapData || []}
                                    options={{
                                        title: 'Redemption Heatmap',
                                        tooltip: { isHtml: true }
                                    }}
                                    width="100%"
                                    height="300px"
                                />
                            </Card>
                        </Col>
                    )}
                         {/* Commuter Demographics */}
                         {redemptionAnalytics.commuterDemographics && (
                        <Col sm={12} md={6} lg={6} xl={6} className="mt-4">
                            <Card className="card-wrapper p-4">
                                <h3 className="chart-heading">Commuter Demographics</h3>
                                <Chart
                                    chartType="PieChart"
                                    data={(() => {
                                        const ageCategories = ['18 to 29', '30 to 39', '40 to 49', '50 to 59', '60 to 69', '70 to 79', '80 or over'];
                                        if (!Array.isArray(redemptionAnalytics.commuterDemographics) || redemptionAnalytics.commuterDemographics.length < 2)
                                            return redemptionAnalytics.commuterDemographics;
                                        const [header, ...rows] = redemptionAnalytics.commuterDemographics;
                                        const mappedRows = ageCategories.map((cat) => {
                                            const found = rows.find(([label]) => label === cat);
                                            return [cat, found ? found[1] : 0];
                                        });
                                        return [header, ...mappedRows];
                                    })()}
                                    options={{ title: 'Commuter Demographics (Age)' }}
                                    width="100%"
                                    height="300px"
                                />
                            </Card>
                        </Col>
                    )}
                </Row>
            )}
        </Container>
    );
};

export default Home;
